'use client';

import { c as _c } from "react/compiler-runtime";
import type { DetailHomeGiftProductResponse } from '__generated__/api/unauth';
import { Button } from '@common/components';
import { AnimatePresence, motion } from 'framer-motion';
import { Fragment, useEffect, useMemo, useState } from 'react';
import CountUp from 'react-countup';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { CartCount } from '../CartItems/CartCount';
import { OptionDropdown } from './OptionDropdown';
export interface SelectedOption {
  optionGroupId: number;
  optionItemId: number;
  optionItemName: string;
  optionGroupName: string;
  extraPrice: number;
}
export interface OptionSetWithQuantity {
  options: SelectedOption[];
  quantity: number;
}
interface OptionSelectBottomSheetProps {
  opened: boolean;
  onClose: () => void;
  productData: DetailHomeGiftProductResponse;
  onConfirm: (optionSets: OptionSetWithQuantity[]) => void;
  /** 수정 모드 여부 */
  isEditMode?: boolean;
  /** 수정 모드일 때 기존 옵션 세트들 */
  initialOptionSets?: OptionSetWithQuantity[];
  /** 삭제 핸들러 (수정 모드에서 옵션 삭제 시) */
  onDelete?: () => void;
}
export const OptionSelectBottomSheet = t0 => {
  const $ = _c(68);
  const {
    opened,
    onClose,
    productData,
    onConfirm,
    isEditMode: t1,
    initialOptionSets: t2,
    onDelete
  } = t0;
  const isEditMode = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const initialOptionSets = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = new Map();
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [selectedOptions, setSelectedOptions] = useState(t4);
  const [quantity, setQuantity] = useState(1);
  const [showValidation, setShowValidation] = useState(false);
  const basePrice = productData.requiredDonationAmount ?? 0;
  let t5;
  if ($[3] !== productData.optionGroupInfoList) {
    t5 = productData.optionGroupInfoList ?? [];
    $[3] = productData.optionGroupInfoList;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const optionGroups = t5;
  let t6;
  let t7;
  if ($[5] !== initialOptionSets || $[6] !== isEditMode || $[7] !== opened || $[8] !== optionGroups) {
    t6 = () => {
      if (!opened) {
        setSelectedOptions(new Map());
        setQuantity(1);
        setShowValidation(false);
        return;
      }
      if (isEditMode && initialOptionSets.length > 0 && optionGroups.length > 0) {
        const map = new Map();
        const firstSet = initialOptionSets[0];
        firstSet.options.forEach(opt => {
          const matchingGroup = optionGroups.find(g => g.optionItemInfoList?.some(item => item.optionItemId === opt.optionItemId));
          if (matchingGroup) {
            const groupId = matchingGroup.optionGroupId ?? 0;
            const optionItem = matchingGroup.optionItemInfoList?.find(item_0 => item_0.optionItemId === opt.optionItemId);
            map.set(groupId, {
              optionGroupId: groupId,
              optionItemId: opt.optionItemId,
              optionItemName: optionItem?.itemName ?? opt.optionItemName,
              optionGroupName: matchingGroup.optionGroupName ?? "",
              extraPrice: optionItem?.extraPrice ?? opt.extraPrice
            });
          }
        });
        if (map.size > 0) {
          setSelectedOptions(map);
          setQuantity(firstSet.quantity);
        }
      }
    };
    t7 = [opened, isEditMode, initialOptionSets, optionGroups];
    $[5] = initialOptionSets;
    $[6] = isEditMode;
    $[7] = opened;
    $[8] = optionGroups;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let extra;
  if ($[11] !== selectedOptions) {
    extra = 0;
    selectedOptions.forEach(opt_0 => {
      extra = extra + opt_0.extraPrice;
      extra;
    });
    $[11] = selectedOptions;
    $[12] = extra;
  } else {
    extra = $[12];
  }
  const totalExtraPrice = extra;
  let t8;
  bb0: {
    if (selectedOptions.size === 0) {
      t8 = basePrice;
      break bb0;
    }
    t8 = (basePrice + totalExtraPrice) * quantity;
  }
  const totalPrice = t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = (optionGroupId, optionItemId, optionItemName, optionGroupName, extraPrice) => {
      setSelectedOptions(prev => {
        const newMap = new Map(prev);
        newMap.set(optionGroupId, {
          optionGroupId,
          optionItemId,
          optionItemName,
          optionGroupName,
          extraPrice
        });
        return newMap;
      });
      setShowValidation(false);
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const handleOptionSelect = t9;
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = newQuantity => {
      setQuantity(newQuantity);
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const handleQuantityChange = t10;
  let t11;
  if ($[15] !== optionGroups) {
    t11 = optionGroups.filter(_temp).map(_temp2);
    $[15] = optionGroups;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const requiredGroupIds = t11;
  let t12;
  if ($[17] !== requiredGroupIds || $[18] !== selectedOptions) {
    let t13;
    if ($[20] !== selectedOptions) {
      t13 = id => selectedOptions.has(id);
      $[20] = selectedOptions;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    t12 = requiredGroupIds.every(t13);
    $[17] = requiredGroupIds;
    $[18] = selectedOptions;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const allRequiredSelected = t12;
  let handleClose;
  let handleConfirm;
  if ($[22] !== allRequiredSelected || $[23] !== onClose || $[24] !== onConfirm || $[25] !== quantity || $[26] !== selectedOptions) {
    handleConfirm = () => {
      if (!allRequiredSelected) {
        setShowValidation(true);
        return;
      }
      const options = Array.from(selectedOptions.values());
      onConfirm([{
        options,
        quantity
      }]);
      handleClose();
    };
    handleClose = () => {
      setSelectedOptions(new Map());
      setQuantity(1);
      setShowValidation(false);
      onClose();
    };
    $[22] = allRequiredSelected;
    $[23] = onClose;
    $[24] = onConfirm;
    $[25] = quantity;
    $[26] = selectedOptions;
    $[27] = handleClose;
    $[28] = handleConfirm;
  } else {
    handleClose = $[27];
    handleConfirm = $[28];
  }
  const t13 = isEditMode ? "\uC635\uC158 \uBCC0\uACBD" : "\uC635\uC158 \uC120\uD0DD";
  const t14 = isEditMode ? "\uC635\uC158 \uBCC0\uACBD" : "\uC635\uC158 \uC120\uD0DD";
  let t15;
  if ($[29] !== optionGroups || $[30] !== selectedOptions) {
    let t16;
    if ($[32] !== selectedOptions) {
      t16 = group => {
        const groupOptions = (group.optionItemInfoList ?? []).map(_temp3);
        const selectedOptionInGroup = selectedOptions.get(group.optionGroupId ?? 0);
        return <OptionDropdown key={group.optionGroupId} groupName={group.optionGroupName ?? "\uC0C1\uD488\uC635\uC158 \uC120\uD0DD"} options={groupOptions} selectedOptionItemId={selectedOptionInGroup?.optionItemId} requiredYN={group.requiredYN} onSelect={option => {
          handleOptionSelect(group.optionGroupId ?? 0, option.optionItemId, option.optionItemName, group.optionGroupName ?? "", option.extraPrice);
        }} />;
      };
      $[32] = selectedOptions;
      $[33] = t16;
    } else {
      t16 = $[33];
    }
    t15 = optionGroups.map(t16);
    $[29] = optionGroups;
    $[30] = selectedOptions;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[34] !== allRequiredSelected || $[35] !== showValidation) {
    t16 = showValidation && !allRequiredSelected && <p className="text-R-500 typo-caption1">구성품을 선택해주세요.</p>;
    $[34] = allRequiredSelected;
    $[35] = showValidation;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t15 || $[38] !== t16) {
    t17 = <div className="flex-1 overflow-y-auto"><div className="flex flex-col gap-16">{t15}{t16}</div></div>;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== allRequiredSelected || $[41] !== onDelete || $[42] !== quantity) {
    t18 = allRequiredSelected && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      height: {
        duration: 0.3,
        ease: "easeOut"
      },
      opacity: {
        duration: 0.2,
        delay: 0.1
      }
    }} className="overflow-hidden"><div className="mt-16 flex items-center justify-between"><span className="font-500 text-Gray-800 typo-body3">수량</span><CartCount count={quantity} onCountChange={handleQuantityChange} onDelete={onDelete} /></div></motion.div>;
    $[40] = allRequiredSelected;
    $[41] = onDelete;
    $[42] = quantity;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t18) {
    t19 = <AnimatePresence>{t18}</AnimatePresence>;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== allRequiredSelected || $[47] !== totalPrice) {
    t20 = allRequiredSelected && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      height: {
        duration: 0.3,
        ease: "easeOut"
      },
      opacity: {
        duration: 0.2,
        delay: 0.1
      }
    }} className="overflow-hidden"><div className="mt-16 flex items-center justify-between border-t border-Gray-300 pt-16"><span className="font-500 text-Gray-800 typo-body3">기부금액</span><div className="flex items-center gap-2 font-700 typo-body1"><CountUp preserveValue={true} end={totalPrice} duration={0.3} delay={0.2} separator="," /><p>원</p></div></div></motion.div>;
    $[46] = allRequiredSelected;
    $[47] = totalPrice;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t20) {
    t21 = <AnimatePresence>{t20}</AnimatePresence>;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== handleClose || $[52] !== handleConfirm || $[53] !== isEditMode) {
    t22 = <div className="mt-16 flex gap-8 pb-[var(--safe-area-bottom,0px)]">{isEditMode ? <Fragment><Button className="shrink-0 px-20" theme="sub-line" onClick={handleClose}>취소</Button><Button className="flex-1" onClick={handleConfirm}>적용 하기</Button></Fragment> : <Button theme="primary-fill" className="flex-1" onClick={handleConfirm}>장바구니 담기</Button>}</div>;
    $[51] = handleClose;
    $[52] = handleConfirm;
    $[53] = isEditMode;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t19 || $[56] !== t21 || $[57] !== t22) {
    t23 = <div className="shrink-0">{t19}{t21}{t22}</div>;
    $[55] = t19;
    $[56] = t21;
    $[57] = t22;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== t17 || $[60] !== t23) {
    t24 = <div className="flex max-h-[70dvh] flex-col">{t17}{t23}</div>;
    $[59] = t17;
    $[60] = t23;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== handleClose || $[63] !== opened || $[64] !== t13 || $[65] !== t14 || $[66] !== t24) {
    t25 = <ResponsiveDialog opened={opened} onClose={handleClose} drawerType="bottom" title={t13} modalHeader={t14}>{t24}</ResponsiveDialog>;
    $[62] = handleClose;
    $[63] = opened;
    $[64] = t13;
    $[65] = t14;
    $[66] = t24;
    $[67] = t25;
  } else {
    t25 = $[67];
  }
  return t25;
};
function _temp(g_0) {
  return g_0.requiredYN;
}
function _temp2(g_1) {
  return g_1.optionGroupId ?? 0;
}
function _temp3(item_1) {
  return {
    optionItemId: item_1.optionItemId ?? 0,
    optionItemName: item_1.itemName ?? "",
    extraPrice: item_1.extraPrice ?? 0,
    isSoldOut: item_1.displaySoldOutYN ?? false
  };
}